'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgLocation(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8.014 2A4.32 4.32 0 003.7 6.314c0 2.57 2.724 6.114 3.84 7.464a.612.612 0 00.943 0l.195-.237c1.213-1.493 3.65-4.795 3.65-7.227A4.32 4.32 0 008.015 2zm0 1.125a3.194 3.194 0 013.19 3.19c0 1.476-1.185 3.65-2.832 5.8l-.36.46c-1.838-2.313-3.187-4.68-3.187-6.26a3.194 3.194 0 013.19-3.19zM8.013 5a1.11 1.11 0 00-1.125 1.125A1.11 1.11 0 008.013 7.25a1.11 1.11 0 001.125-1.125A1.11 1.11 0 008.013 5z", fill: "currentColor" }))));
}

module.exports = SvgLocation;
//# sourceMappingURL=Location.js.map
